(function () {
   
    /**
     * The mega menu module
     * 
     * @module megaMenu
     */
    var megaMenu = {

        /**
         * Initialise the mega menu listeners for keyboard navigation
         * 
         * @memberof module:megaMenu
         */
        'init': function () {

            // Top level items
            var topNavItems = document.querySelectorAll('.qld__main-nav__item-title > a ');
            topNavItems.forEach(function (item) {
                item.addEventListener('keydown', handleTopNavKeydown);
                item.addEventListener('focusin', toggleMenu);
                item.addEventListener('focusout', handleTopNavFocusout);
            });

            // Mega menu items
            var menuItems = document.querySelectorAll('.qld__main-nav__menu-sub a');
            menuItems.forEach(function (item) {
                item.addEventListener('keydown', handleMenuKeypress);
            });
        
        },

    };

    /**
     * Handle keydown on top level nav item to close the menu
     * if ESCAPE or UP key are pressed
     * 
     * @memberof module:megaMenu
     * @instance
     * @private
     * 
     * @param {Document.event} e 
     */
    function handleTopNavKeydown(e) {
        var key = e.keyCode;
        console.log('handleTopNavKeyDown:', key);
        // ESC or UP ARROW
        if (key == 27 || key == 38) {
            toggleMenu(e);
        }
    }

    /**
     * Handle focusout of top level nav items.
     * Close the menu, unless we have tabbed within
     * 
     * @memberof module:megaMenu
     * @instance
     * @private
     * 
     * @param {Document.event} e 
     */
    function handleTopNavFocusout(e) {
        var link = e.target;
        var navItem = link.closest('.qld__main-nav__item');
        if (!navItem) {
            console.warn('Nav item not found.');
            return;  // Early exit if navItem is not found
        }
    
        var expanded = navItem.classList.contains('expanded');
        var menu = navItem.querySelector('.qld__main-nav__menu-sub');
    
        setTimeout(function() {
            // Ensure menu is not null before using it
            if (menu) {
                var menuHasFocus = menu.contains(document.activeElement);
                if (!menuHasFocus && expanded) {
                    toggleMenu(e);
                }
            } else {
                console.warn('Menu element not found within nav item.');
            }
        }, 20);
    }

    /**
     * Toggle the mega menu open/closed
     * 
     * @memberof module:megaMenu
     * @instance
     * @private
     * 
     * @param {Document.event} e 
     */
    function toggleMenu(e) {
        var link = e.target;
        var navItem = link.closest('.qld__main-nav__item');
        var subMenu = link.closest('.qld__main-nav__menu-sub');
        var menuButton = navItem.querySelector('.qld__main-nav__item-toggle');

        if (!subMenu || !menuButton) return;

        var subMenuExpanded = subMenu.classList.contains('qld__accordion--open');
        // var menuButtonExpanded = menuButton.classList.contains('qld__accordion--open');
        var expanded = navItem.classList.contains('expanded');

        if (!expanded && !subMenuExpanded) {
            navItem.classList.add('expanded');
            subMenu.classList.remove('qld__accordion--closed');
            subMenu.classList.add('qld__accordion--open');
            menuButton.classList.remove('qld__accordion--closed')
            menuButton.classList.add('qld__accordion--open');

            setTimeout(function() {
                document.addEventListener('click', handleBackgroundClick);
                document.addEventListener('keydown', handleKeydown);
            }, 30);
        } else {
            closeMenu(navItem, subMenu, menuButton);
        }
    }

    function closeMenu(navItem, subMenu, menuButton) {
        navItem.classList.remove('expanded');
        subMenu.classList.remove('qld__accordion--open');
        subMenu.classList.add('qld__accordion--closed');
        menuButton.classList.remove('qld__accordion--open');
        menuButton.classList.add('qld__accordion--closed');

        document.removeEventListener('click', handleBackgroundClick);
        document.removeEventListener('keydown', handleKeydown);
    }

    function handleKeydown(e) {
        if (e.key === 'Escape') {
            var activeSubMenu = document.querySelector('.qld__accordion--open');
            if (activeSubMenu) {
                var navItem = activeSubMenu.closest('.qld__main-nav__item');
                var menuButton = navItem.querySelector('.qld__main-nav__item-toggle')
                closeMenu(navItem, activeSubMenu, menuButton);
            }
        }
    }

    /**
     * Close the mega menu if the user clicks outside of it while opened
     * 
     * @memberof module:megaMenu
     * @instance
     * @private
     * 
     * @param {Document.event} e 
     */
    function handleBackgroundClick(e) {
        var target = e.target;
        var nav = document.querySelector('.qld__main-nav__menu-inner');

        // If clicked outside nav
        if (!nav.contains(target)) {

            // Close any expanded menu(s)
            document.querySelectorAll('.qld__main-nav__item.expanded').forEach(function(item) {
                item.classList.remove('expanded');
            });

            // Remove listener
            document.removeEventListener('click', handleBackgroundClick);
        }
    }

    /**
     * Handle keypress for item within mega menu.
     * Close the menu on press of ESCAPE or UP
     * After TAB press, check if focus is still within menu,
     * and close if it's not
     * 
     * @memberof module:megaMenu
     * @instance
     * @private
     * 
     * @param {Document.event} e 
     */
    function handleMenuKeypress(e) {
        var link = e.target;
        var key = e.keyCode;
        var navItem = link.closest('.qld__main-nav__item');
        var menu = link.closest('.qld__main-nav__menu-sub');

        // ESC or UP ARROW
        if (key == 27 || key == 38) {
            console.log('handleManuKeypress:', key);
            navItem.querySelector('.qld__main-nav__item-title > a').focus();
            toggleMenu(e);
        }

        // If TAB key is pressed only (not SHIFT + TAB)
        if (key === 9 && !e.shiftKey) {
            setTimeout(function() {
                //Check to see if menu exists
                if (menu) {
                    var menuHasFocus = menu.contains(document.activeElement) ? true : false;
                    
                    if (!menuHasFocus) {
                        toggleMenu(e);
                    }
                } else {
                    console.warn('Menu element is not found.');
                }
            }, 20);
        }
        
    }

    window.addEventListener('DOMContentLoaded', function () {
        megaMenu.init();
    });

}());
